import React, { useState } from 'react';
import { IncomeExpensePageShell, ActionButton } from './components/IncomeExpensePageShell';
import { PlaceholderTabPanel } from './components/PlaceholderTabPanel';
import { IncomeExpenseTabDefinition } from './tabConfigs';

interface TabbedIncomeExpensePageProps {
  pageTitle: string;
  pageCode: string;
  tabs: IncomeExpenseTabDefinition[];
  defaultTabId?: string;
  actions?: ActionButton[];
  badge?: number;
}

export const TabbedIncomeExpensePage: React.FC<TabbedIncomeExpensePageProps> = ({
  pageTitle,
  pageCode,
  tabs,
  defaultTabId,
  actions,
  badge,
}) => {
  const [activeTab, setActiveTab] = useState(defaultTabId ?? tabs[0]?.id ?? '');
  const activePanel = tabs.find((tab) => tab.id === activeTab)?.panel ?? tabs[0]?.panel;

  return (
    <IncomeExpensePageShell
      pageTitle={pageTitle}
      pageCode={pageCode}
      tabs={tabs.map(({ id, label }) => ({ id, label }))}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      actions={actions}
      badge={badge}
    >
      {activePanel && <PlaceholderTabPanel config={activePanel} />}
    </IncomeExpensePageShell>
  );
};
